<section class="border-b border-border bg-surface px-4 py-7 sm:px-6 lg:px-8 shadow-sm">
      <div class="mx-auto max-w-7xl flex flex-col md:flex-row md:items-center md:justify-between gap-6">
            <div class="space-y-1.5 max-w-3xl">
                  <!-- Badged Breadcrumb Tracker -->
                  <div class="inline-flex items-center gap-2 px-2.5 py-1 bg-primary/10 border border-primary/20 rounded-xl mb-2">
                        <span class="w-1.5 h-1.5 rounded-full bg-primary animate-pulse"></span>
                        <span class="text-[10px] font-black uppercase tracking-widest text-primary">
                              {{ 'ownerDashboard.header.title' | translate }}
                        </span>
                  </div>

                  <!-- Main Dynamic Title -->
                  <h1 class="text-2xl sm:text-3xl font-black tracking-tight text-text-primary flex items-center gap-3">
                        <i class="fa-solid fa-building-user text-primary"></i>
                        {{ 'ownerDashboard.header.title' | translate }}
                  </h1>

                  <!-- Subtitle Description -->
                  <p class="text-xs sm:text-sm font-medium text-text-secondary leading-relaxed max-w-2xl">
                        {{ 'ownerDashboard.header.subtitle' | translate }}
                  </p>
            </div>

            <!-- Action Button -->
            <button (click)="onAddProperty()"
                  class="w-full md:w-auto px-6 py-3 bg-primary text-white font-bold rounded-xl hover:bg-primary-hover hover:shadow-primary-glow active:scale-95 transition-all duration-200 flex items-center justify-center gap-2 border border-primary-border shrink-0 mt-4 md:mt-0">
                  <i class="fa-solid fa-plus text-sm"></i>
                  {{ 'ownerDashboard.header.addUnit' | translate }}
            </button>
      </div>

      <!-- Stats Grid -->
      <div class="mx-auto max-w-7xl mt-8 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6">
            <!-- Total Properties -->
            <div class="bg-surface-elevated border border-border rounded-2xl p-5 hover:border-primary-border transition-all duration-300 shadow-subtle group">
                  <div class="flex items-center justify-between mb-4">
                        <div class="w-10 h-10 bg-primary-soft rounded-xl flex items-center justify-center text-primary border border-primary-border group-hover:scale-110 transition-transform">
                              <i class="fa-solid fa-house text-lg"></i>
                        </div>
                        <span class="inline-flex items-center gap-1.5 text-[10px] font-bold uppercase tracking-wider bg-success-soft text-success px-2 py-1 rounded-md border border-success-border shadow-sm">
                              <span class="w-1.5 h-1.5 bg-success rounded-full animate-pulse"></span>
                              {{ 'ownerDashboard.header.live' | translate }}
                        </span>
                  </div>
                  <div class="text-2xl md:text-3xl font-black text-text-primary mb-1 tracking-tight">
                        {{ totalListings | number:'1.0-2' }}
                  </div>
                  <div class="text-text-secondary text-xs font-bold uppercase tracking-wider">
                        {{ 'ownerDashboard.header.totalProperties' | translate }}
                  </div>
            </div>

            <!-- Total Views -->
            <div class="bg-surface-elevated border border-border rounded-2xl p-5 hover:border-primary-border transition-all duration-300 shadow-subtle group">
                  <div class="flex items-center justify-between mb-4">
                        <div class="w-10 h-10 bg-surface-hover rounded-xl flex items-center justify-center text-text-muted border border-border group-hover:scale-110 transition-transform">
                              <i class="fa-solid fa-eye text-lg"></i>
                        </div>
                        <span class="text-[10px] font-bold uppercase tracking-wider bg-surface text-text-muted px-2 py-1 rounded-md border border-border">
                              {{ 'ownerDashboard.header.views' | translate }}
                        </span>
                  </div>
                  <div class="text-2xl md:text-3xl font-black text-text-primary mb-1 tracking-tight">
                        {{ (overview?.totalViews ?? 0) | number:'1.0-2' }}
                  </div>
                  <div class="text-text-secondary text-xs font-bold uppercase tracking-wider">
                        {{ 'ownerDashboard.header.totalViews' | translate }}
                  </div>
            </div>

            <!-- Total Requests -->
            <div class="bg-surface-elevated border border-border rounded-2xl p-5 hover:border-primary-border transition-all duration-300 shadow-subtle group">
                  <div class="flex items-center justify-between mb-4">
                        <div class="w-10 h-10 bg-warning-soft rounded-xl flex items-center justify-center text-warning border border-warning-border group-hover:scale-110 transition-transform">
                              <i class="fa-solid fa-comments text-lg"></i>
                        </div>
                        <span class="text-[10px] font-bold uppercase tracking-wider bg-warning-soft text-warning px-2 py-1 rounded-md border border-warning-border">
                              {{ 'ownerDashboard.header.new' | translate }}
                        </span>
                  </div>
                  <div class="text-2xl md:text-3xl font-black text-text-primary mb-1 tracking-tight">
                        {{ (overview?.newRequests ?? 0) | number:'1.0-2' }}
                  </div>
                  <div class="text-text-secondary text-xs font-bold uppercase tracking-wider">
                        {{ 'ownerDashboard.header.totalRequests' | translate }}
                  </div>
            </div>

            <!-- Total Revenue -->
            <div class="bg-surface-elevated border border-border rounded-2xl p-5 hover:border-primary-border transition-all duration-300 shadow-subtle group">
                  <div class="flex items-center justify-between mb-4">
                        <div class="w-10 h-10 bg-success-soft rounded-xl flex items-center justify-center text-success border border-success-border group-hover:scale-110 transition-transform">
                              <i class="fa-solid fa-dollar-sign text-lg"></i>
                        </div>
                        <span class="text-[10px] font-bold uppercase tracking-wider bg-surface text-text-muted px-2 py-1 rounded-md border border-border">
                              {{ 'ownerDashboard.header.month' | translate }}
                        </span>
                  </div>
                  <div class="text-2xl md:text-3xl font-black text-text-primary mb-1 tracking-tight truncate flex items-baseline gap-1">
                        <span class="text-sm font-bold text-text-muted">EGP</span>
                        {{ monthlyRevenueAmount | number:'1.0-2' }}
                  </div>
                  <div class="text-text-secondary text-xs font-bold uppercase tracking-wider">
                        {{ 'ownerDashboard.header.monthlyRevenue' | translate }}
                  </div>
            </div>
      </div>

      <!-- Status Messages Indicator -->
      <div *ngIf="isLoading"
            class="mx-auto max-w-7xl mt-6 flex items-center gap-3 text-xs font-bold uppercase tracking-wider text-primary bg-primary-soft px-4 py-3 rounded-xl w-fit border border-primary-border shadow-sm">
            <i class="fas fa-circle-notch fa-spin text-sm"></i>
            <span>{{ 'ownerDashboard.header.loading' | translate }}</span>
      </div>

      <div *ngIf="!isLoading && errorMessage"
            class="mx-auto max-w-7xl mt-6 flex items-center gap-3 text-xs font-bold uppercase tracking-wider text-danger bg-danger-soft px-4 py-3 rounded-xl w-fit border border-danger-border shadow-sm">
            <i class="fas fa-exclamation-triangle text-sm"></i>
            <span>{{ errorMessage }}</span>
      </div>
</section>